import { Box, Grid, Typography } from "@mui/material";
import React from "react";

const Contact = () => {
  return (
    <Grid
      container
      id="contact"
      spacing={2}
      sx={{
        width: "100%",
        mt: 5,
        mx: "auto",
        px: { xs: 2, md: 10 },
        py: { xs: 2, md: 5 },
      }}
    >
      <Box
        sx={{
          border: { xs: "none", md: "1px solid #1976d2" },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          p: { xs: 2, md: 5 },
          borderRadius: 4,
          mx: "auto",
        }}
      >
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              width: "100%",
              height: { xs: 300, md: 400 },
              borderRadius: 2,
              overflow: "hidden",
            }}
          >
            <iframe
              title="Podar ORT Mumbai Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3936.6352612923465!2d77.5893427!3d13.096915399999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae195977bbaf6d%3A0x163efdde1ad52672!2sPodar%20Prep%20Plus%20Preschool%20%26%20Day%20care%20-Yelahanka%20new%20town!5e1!3m2!1sen!2sin!4v1747984882095!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </Box>
        </Grid>

        {/* Right: Contact Details */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              // justifyContent: "center",
              px: { xs: 1, md: 4 },
              mt: { xs: 5, md: 0 },
            }}
          >
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: { xs: 18, md: 25 },
                textAlign: "justify",
              }}
            >
              Podar Prep Plus Preschool & Day care - Yelahanka new town
            </Typography>

            <Typography sx={{ textAlign: "justify", mt: 1 }}>
              9A1 9A2, Yelahanka Satellite Town, Next to KK Kids Hospital,
              Yelahanka, Bengaluru, Karnataka 560064
            </Typography>

            <Box
              sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 2 }}
            >
              <Typography sx={{ fontSize: { xs: 15, md: 18 } }}>
                <strong>Headmistress Name:</strong> Asha Kiran
              </Typography>

              <Typography sx={{ fontSize: { xs: 15, md: 18 } }}>
                <strong> Headmistress Mobile No:</strong> +91 9844565757
              </Typography>

              <Typography sx={{ fontSize: { xs: 15, md: 18 } }}>
                <strong>Headmistress Email:</strong> ppyelahanka@podarprep.com
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Box>
    </Grid>
  );
};

export default Contact;

